export default "__VITE_ASSET__kdHsICis__"